import tinycolor from 'tinycolor2'
import Env from '../base/env.js'
import Barba from 'barba.js'
import {TimelineLite, TweenLite} from 'gsap';

class BarbaPopin
{
    constructor()
    {
        // Dom
        this.$popin = Env.$popinView
        this.$receptor = Env.$popinContent
        this.$btnClose = this.$popin.querySelectorAll('.jsClose')
        this.$btnCloseOverlay = this.$popin.querySelector('.jsCloseOverlay')
        // Objects
        this.klassPopinContent = '.barbapopin-content'
        this.timeoutBgAnim = false
        // Flags
        this.transitionProgress = false
        this.ENABLED = false
        // Fns
        this.events()
    }

    attach(data,withAnim = true)
    {
        const $content = data.querySelector(this.klassPopinContent)
        $content.classList.add('popin--mode')
        this.$receptor.appendChild($content)
        Env.framework.UI.trackerPopinProduct()
        if(withAnim) {
            this.open()
        }
    }

    close()
    {
        if(this.ENABLED) {
            const previousUrl = document.querySelector(".barba-container").getAttribute("data-currenturl");
            window.history.pushState(null, null, previousUrl);
            Barba.HistoryManager.add(previousUrl);
            this.transitionClose()
        }
    }

    events()
    {
        for(const $btnClose of this.$btnClose) {
            $btnClose.addEventListener('click',()=>{
                this.close()
            })
        }
        this.$btnCloseOverlay.addEventListener('click',()=>{
            this.close()
        })
    }

    open()
    {
        if(this.ENABLED == false) {
            this.transitionOpen()
        }
    }

    reset()
    {
        this.$receptor.innerHTML = ''
        this.transitionProgress = false
        this.ENABLED = false
    }

    transitionClose(fnComplete='')
    {
        let timeline = new TimelineLite()
        const dimensions = this.$receptor.getBoundingClientRect()
        const $content = this.$receptor.querySelector(this.klassPopinContent)

        this.transitionProgress = true
        this.ENABLED = false

        timeline.add([
            TweenLite.to(this.$btnClose[0], .4 , { autoAlpha : 0 , y : 50 , ease : Cubic.easeInOut }),
            TweenLite.to(this.$btnClose[1], .4 , { autoAlpha : 0 , ease : Cubic.easeInOut }),
            TweenLite.fromTo(this.$receptor , .5 , { clip : `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)` } , { clip : `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)` , ease : Power3.easeInOut , delay : .2 }),
        ])
        timeline.add(()=>{
            this.$popin.classList.remove('is--active')
            Env.$html.classList.remove('popin--isOpened')
            for(const $btnClose of this.$btnClose) {
                $btnClose.removeAttribute('style')
            }
            this.$receptor.removeAttribute('style')
            this.reset()
            if(typeof fnComplete != 'undefined' && typeof fnComplete == 'function') {
                fnComplete()
            }
            this.timeoutBgAnim = setTimeout(() => {
                Env.$popinOverlay.removeAttribute('style')
                Env.$html.classList.remove('popin--isDark')
            }, 850);
        })
    }

    transitionOpen(fnComplete='')
    {
        let timeline = new TimelineLite({ delay : .3 })
        const dimensions = this.$receptor.getBoundingClientRect()
        const $content = this.$receptor.querySelector(this.klassPopinContent)
        const $getBg = document.querySelector('.jsPopin--bg')
        let getBg;
        if($getBg !== null) {
             getBg = $getBg.value
        } else {
            getBg = '#666'
        }



        if(getBg != null) {
            Env.$popinOverlay.style.backgroundColor = getBg
        }
        if(tinycolor(getBg).isLight()){
            Env.$html.classList.add('popin--isDark')
        }

        this.$popin.classList.add('is--active')
        Env.$html.classList.add('popin--isOpened')
        this.ENABLED = true
        this.transitionProgress = true
        clearTimeout(this.timeoutBgAnim)

        timeline.add([
            TweenLite.fromTo(this.$receptor , .5 , { clip : `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)` } , { clip : `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)` , ease : Power3.easeOut }),
            TweenLite.fromTo($content, .6 , { autoAlpha : 0 , y : 50 } , { autoAlpha : 1 , y : 0 , ease : Cubic.easeOut , delay : .3 }),
            TweenLite.fromTo(this.$btnClose[0], .4 , { autoAlpha : 0 , y : 50 } , { autoAlpha : 1 , y : 0 , ease : Cubic.easeOut , delay : .15 }),
            TweenLite.fromTo(this.$btnClose[1], .4 , { autoAlpha : 0 } , { autoAlpha : 1 , ease : Cubic.easeOut , delay : .4 })
        ])
        timeline.add(()=>{
            this.transitionProgress = false
            TweenLite.set(this.$receptor , { clearProps : 'clip' })
            TweenLite.set($content , { clearProps : 'all' })
            if(typeof fnComplete != 'undefined' && typeof fnComplete == 'function') {
                fnComplete()
            }
        })
    }
}

export default BarbaPopin;